var _defs, _circle, _path, _line, _polyline, _path2, _path3, _path4, _polyline2, _polyline3, _rect, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageoffered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#00a0df;stroke-width:2.25px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MS_Iconography_MS_Core_Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 47.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.93,38.51s-2.23,1.28-3.1,1.16-6.95-2.19-11.48-1.28-6.85,1.16-7.87,2.33-4.11,5.09-4.11,5.09-1.49,1.8,0,2.8c0,0,.57,1.11,2.7,0l7-3.68a2.6,2.6,0,0,1,2.22.2c1,.69,16.52,10.69,16.52,10.69s2.3,2.09.58,4c0,0-1.23,1.81-4,.27s-8.29-5-8.29-5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.69,
    y1: 56.45,
    x2: 74.11,
    y2: 51.64
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "28.99 32.48 37.98 40.16 43.09 41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.16,60.45S65,65.24,60.82,64c-5.69-3.19-7.4-4.18-7.4-4.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.82,64s.87,5.12-3.94,3.4c-4.65-2.46-5.22-2.71-5.22-2.71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.35,67.6S55,70,52.49,69.5s-5.78-1.39-5.78-1.39"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "32.09 57.54 27.35 50.94 18.45 47.83"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "81.02 50.55 75.5 53.5 64.77 36.21 70.1 32.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.87,
    y: 55.48,
    width: 4.22,
    height: 11.32,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(42.17 -10.71) rotate(35.18)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31,62.8h0a2.12,2.12,0,0,1-.51-2.94L33,56.47A2.11,2.11,0,0,1,35.9,56h0a2.11,2.11,0,0,1,.51,2.94L33.9,62.29A2.12,2.12,0,0,1,31,62.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.92,67.82h0a2.12,2.12,0,0,1-.75-2.89l2.89-4.34a2.1,2.1,0,0,1,2.88-.75h0a2.12,2.12,0,0,1,.75,2.89l-2.88,4.34A2.12,2.12,0,0,1,38.92,67.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.86,69.82h0a2.13,2.13,0,0,1-.75-2.89l1.74-2.46a2.13,2.13,0,0,1,2.89-.75h0a2.12,2.12,0,0,1,.75,2.89l-1.74,2.46A2.12,2.12,0,0,1,42.86,69.82Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageoffered);
export default __webpack_public_path__ + "static/media/packageoffered.b857f5b67fb2548d83fcb19f86446d06.svg";
export { ForwardRef as ReactComponent };